import { Routes } from '@angular/router';
import { XlogAuthGuard } from './guards/xlog-auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'monitor',
    pathMatch: 'full',
  },
  {
    path: 'monitor',
    canActivate: [XlogAuthGuard],
    loadChildren: () => import('./modules/monitor/monitor.routes').then(m => m.MONITOR_ROUTES),
    data: {
      role: 'module_monitor_resourcepanorama',
    },
  },
  {
    path: 'settings',
    canActivate: [XlogAuthGuard],
    loadChildren: () => import('./modules/settings/settings.routes').then(m => m.SETTINGS_ROUTES),
    data: {
      role: 'app_resourcepanorama',
    },
  },
  {
    path: 'reports',
    canActivate: [XlogAuthGuard],
    loadChildren: () => import('./modules/reports/reports.routes').then(m => m.REPORTS_ROUTES),
    data: {
      role: 'module_reports_resourcepanorama',
    },
  },
];
